import * as THREE from 'three';
import { jsondan } from '../../FikoThreeType';
import { FikoGrup } from '../FikoGrup';
import { FikoImporter } from '../FikoImporter';
import { FikoSahne } from '../FikoSahne';
import { FikoAktivitePuntalama } from './Aktiviteler/dialog-fiko-puntalama/FikoPuntalama';
import { FikoApt } from './FikoApt';
import { FikoGCodeGenerator } from './FikoGCodeGenerator';
import { FikoVektorTakimYol3D } from './FikoVektorTakimYol3d';
import { FikoTakimYolu } from './FikoTakimYolu';

declare var $: any;

export class Fikogram extends FikoGrup {
    override type: any = "Fikogram";
    /** */
    loader: THREE.FileLoader = new THREE.FileLoader();

    public override get liste(): Fikogram[] {
        return this.children as Fikogram[];
    }

    sagButonlar = [
        {
            isim: "G-Code Üret",
            simge: "download",
            tiklandi: () => {
                this.gcodeUret();
            }
        },
        {
            isim: "Similasyon Yap",
            simge: "play",
            tiklandi: () => {
                import('../fiko-similasyon-v1/fiko-similasyon-v1.component').then(m => {
                    const gosterim = this.sahne?.anaGosterim;
                    if (!gosterim?.DialogFiko) return;
                    gosterim.DialogFiko.ac({
                        bilesen: m.FikoSimilasyonV1Component,
                        parametreler: { anaNesne: this },
                        ayarlar: { baslik: 'Similasyon', simgeResim: './simgeler/takimyolu.webp' }
                    });
                });
            }
        }
    ]

    sagMenu: any[] = [
        {
            simge: "download",
            baslik: "G-Code Üret (Fanuc)",
            tiklandi: () => {
                this.gcodeUret('fanuc');
            }
        },
        {
            simge: "download",
            baslik: "G-Code Üret (Siemens)",
            tiklandi: () => {
                this.gcodeUret('siemens840d');
            }
        },
        {
            simge: "download",
            baslik: "G-Code Üret (Haas)",
            tiklandi: () => {
                this.gcodeUret('haas');
            }
        },
        {
            simge: "download",
            baslik: "G-Code Üret (Heidenhain)",
            tiklandi: () => {
                this.gcodeUret('heidenhain');
            }
        },
        {
            simge: "download",
            baslik: "G-Code Üret (GRBL/Mach3)",
            tiklandi: () => {
                this.gcodeUret('grbl');
            }
        },
        {
            tipi: "Ayraç"
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                let _this = this;
                $('body')
                    .toast({
                        message: `Fikogram Ve Tüm Alt Aktiviteleri Silinecektir, Onaylıyormusunuz?`,
                        displayTime: 3000,
                        class: 'black',
                        classActions: 'top attached',
                        actions: [{
                            text: 'Evet Onaylıyorum',
                            class: 'red',
                            click: function () {
                                while (_this.children.length) {
                                    _this.remove(_this.children[0]);
                                }

                                _this.parent.remove(_this);
                                _this.sahne.anaGosterim.aktifItem = null;
                                _this.sahne.anaGosterim.FikoYT.degisti.emit();
                                _this.sahne.anaGosterim.ciz();
                            }
                        }, {
                            text: 'Hayır',
                            class: 'green',
                            click: function () {

                            }
                        }]
                    });
            }
        },
    ]

    aracCubugu: any[] = [
        {
            resim: "./simgeler/punta.webp",
            baslik: "Puntalama",
            tiklandi: () => {
                this.ekle(new FikoAktivitePuntalama(this.sahne));

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        },
        {
            resim: "./simgeler/matkap-ucu.webp",
            baslik: "Delik Programı",
            tiklandi: () => {

            }
        },
        {
            resim: "./simgeler/profil-kontur.webp",
            baslik: "Profil / Çevre İşleme",
            tiklandi: () => {

            }
        },
        {
            tipi: "Ayraç"
        },
        {
            simge: "edit",
            baslik: "Düzenle",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikogram.ac(this);
            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                let _this = this;
                $('body')
                    .toast({
                        message: `Fikoperasyon Ve Tüm Alt Aktiviteleri Silinecektir, Onaylıyormusunuz?`,
                        displayTime: 3000,
                        class: 'black',
                        classActions: 'top attached',
                        actions: [{
                            text: 'Evet Onaylıyorum',
                            class: 'red',
                            click: function () {
                                while (_this.children.length) {
                                    _this.remove(_this.children[0]);
                                }

                                _this.parent.remove(_this);
                                _this.sahne.anaGosterim.aktifItem = null;
                                _this.sahne.anaGosterim.FikoYT.degisti.emit();
                                _this.sahne.anaGosterim.ciz();
                            }
                        }, {
                            text: 'Hayır',
                            class: 'green',
                            click: function () {

                            }
                        }]
                    });
            }
        },
    ]

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/gcode.webp";

    }

    ekleDosyadan(filter?: string) {
        const importer = new FikoImporter(this);
        importer.dosyadan(".FikoApt, .aptsource");
        /*
        var _this = this;
        let input = document.createElement("input");
        input.type = "file";
        input.onchange = ($event: any) => {
            if ($event.target.files && $event.target.files[0]) {
                const dosya: File = $event.target.files[0]
                _this.ekleAptDosyadan(dosya);
            }
        }
        input.click();*/
    }

    ekleAptDosyadan(dosya: any) {
        var _this = this;
        this.loader.load(URL.createObjectURL(dosya),

            (data: any) => {
                let fikoApt = new FikoApt(this.sahne);
                // fikoApt.strApt = data;
                fikoApt.arrayApt = data.split("\n");
                fikoApt.parcala();
                // fikoApt.agactaGorunur = true;
                fikoApt.name = fikoApt.name.replace(".FikoAPT", "").replace(".aptsource", "");
                // _this.add(fikoApt);


                _this.name = fikoApt.name.replace(".FikoAPT", "").replace(".aptsource", "")
                this.userData['FikoArayuz'].simge = fikoApt.userData['FikoArayuz'].simge;

                const index = _this.parent.children.indexOf(_this);

                fikoApt.parent = _this.parent;

                _this.parent.children.splice(index, 0, fikoApt);

                _this.parent.remove(_this);

                _this.sahne.anaGosterim.FikoYT.degisti.emit();
            },
            function (xhr) {
            },
            function (err) {
            }
        );
    }

    isleAptString(aptStr: string) {
        let fikoApt = new FikoApt(this.sahne);
        // fikoApt.strApt = data;
        fikoApt.arrayApt = aptStr.split("\n");
        fikoApt.parcala();
        // fikoApt.agactaGorunur = true;
        fikoApt.name = fikoApt.name.replace(".FikoAPT", "").replace(".aptsource", "");
        // _this.add(fikoApt);

        this.name = fikoApt.name.replace(".FikoAPT", "").replace(".aptsource", "")
        this.userData['FikoArayuz'].simge = fikoApt.userData['FikoArayuz'].simge;

        const index = this.parent.children.indexOf(this);

        fikoApt.parent = this.parent;

        this.parent.children.splice(index, 0, fikoApt);

        this.parent.remove(this);

        this.sahne.anaGosterim.FikoYT.degisti.emit();
    }

    isleAptArray(aptArray: string[]) {
        let fikoApt = new FikoApt(this.sahne);
        // fikoApt.strApt = data;
        fikoApt.arrayApt = aptArray;
        fikoApt.parcala();
        // fikoApt.agactaGorunur = true;
        fikoApt.name = fikoApt.name.replace(".FikoAPT", "").replace(".aptsource", "");
        // _this.add(fikoApt);

        this.name = fikoApt.name.replace(".FikoAPT", "").replace(".aptsource", "")
        this.userData['FikoArayuz'].simge = fikoApt.userData['FikoArayuz'].simge;

        const index = this.parent.children.indexOf(this);

        fikoApt.parent = this.parent;

        this.parent.children.splice(index, 0, fikoApt);

        this.parent.remove(this);

        this.sahne.anaGosterim.FikoYT.degisti.emit();
    }

    tiklandi() {
    }

    ciftTiklandi() {
        // this.sahne.anaGosterim.DialogFikogram.ac(this);
    }

    sagTiklandi() {
    }

    /**
     * Tüm aktivitelerden takım yolu noktalarını topla
     */
    tumTakimYoluNoktalariniTopla(): FikoVektorTakimYol3D[] {
        const tumNoktalar: FikoVektorTakimYol3D[] = [];

        // Tüm children'ı recursive olarak tara
        const noktaTopla = (nesne: any) => {
            // FikoTakimYolu ise noktalarını al
            if (nesne.type === 'FikoTakimYolu' && nesne.noktalar) {
                tumNoktalar.push(...nesne.noktalar);
            }

            // Aktivite ise takimYoluNoktalar'ını al
            if (nesne.takimYoluNoktalar && Array.isArray(nesne.takimYoluNoktalar)) {
                tumNoktalar.push(...nesne.takimYoluNoktalar);
            }

            // Children varsa recursive devam et
            if (nesne.children && Array.isArray(nesne.children)) {
                for (const child of nesne.children) {
                    noktaTopla(child);
                }
            }
        };

        noktaTopla(this);
        return tumNoktalar;
    }

    /**
     * G-Code üret ve indir
     * @param preset Post-processor preset adı (fanuc, haas, siemens840d, heidenhain, mach3, linuxcnc, grbl)
     */
    gcodeUret(preset: 'fanuc' | 'haas' | 'siemens840d' | 'heidenhain' | 'mach3' | 'linuxcnc' | 'grbl' = 'fanuc'): void {
        const noktalar = this.tumTakimYoluNoktalariniTopla();

        if (noktalar.length === 0) {
            console.warn('[Fikogram] G-Code üretilecek takım yolu noktası bulunamadı!');
            if (typeof $ !== 'undefined') {
                $('body').toast({
                    message: 'G-Code üretilecek takım yolu bulunamadı. Önce aktiviteleri hesaplayın.',
                    displayTime: 3000,
                    class: 'warning'
                });
            }
            return;
        }

        try {
            const generator = new FikoGCodeGenerator(preset);
            const gcode = generator.generate(noktalar, this.name || 'Program');
            const stats = generator.getStatistics(noktalar);

            // İstatistikleri konsola yaz
            console.log('[Fikogram] G-Code üretildi:');
            console.log(`  - Toplam satır: ${gcode.split('\n').length}`);
            console.log(`  - Rapid hareket: ${stats.rapidHareket}`);
            console.log(`  - Kesim hareketi: ${stats.kesimHareket}`);
            console.log(`  - Yay hareketi: ${stats.yayHareket}`);
            console.log(`  - Toplam mesafe: ${stats.toplamMesafe.toFixed(2)} mm`);
            console.log(`  - Tahmini süre: ${stats.tahminSure.toFixed(2)} dk`);

            // İndir
            generator.downloadGCode(this.name || 'Program');

            // Bildirim
            if (typeof $ !== 'undefined') {
                $('body').toast({
                    message: `G-Code üretildi (${preset.toUpperCase()}): ${noktalar.length} nokta, ${stats.tahminSure.toFixed(1)} dk`,
                    displayTime: 4000,
                    class: 'success'
                });
            }
        } catch (e) {
            console.error('[Fikogram] G-Code üretim hatası:', e);
            if (typeof $ !== 'undefined') {
                $('body').toast({
                    message: 'G-Code üretim hatası: ' + (e as Error).message,
                    displayTime: 5000,
                    class: 'error'
                });
            }
        }
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid };

        _rslt.children = []
        for (let i = 0; i < this.children.length; i++) {
            const element = this.children[i];
            _rslt.children.push(element.toJSON());
        }

        _rslt.userData = this._serializeUserData();
        _rslt.visible = this.visible;

        return _rslt;

        /*
        const _rslt = super.toJSON(meta);
        return _rslt;
        */
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new Fikogram(sahne, json.isim);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        for (let i = 0; i < json.children.length; i++) {
            let element = json.children[i];
            _rslt.ekle(jsondan(sahne, _rslt, element));
        }

        if (json.userData) _rslt._restoreUserData(json.userData);
        if (json.visible !== undefined) _rslt.visible = json.visible;

        return _rslt;

        /*
        const mtrx = json.matrix;
        delete json.matrix;
        const _rslt = Object.assign(new Fikogram(sahne), json);
        _rslt.matrix.fromArray(mtrx);
        _rslt.layers = new THREE.Layers();
        _rslt.layers.set(json.layers);

        _rslt.parent = parent;

        for (let i = 0; i < _rslt.children.length; i++) {
            let element = _rslt.children[i];
            _rslt.children[i] = jsondan(sahne, _rslt, element);
        }

        return _rslt;
        */
    }
}